import { useSelector } from 'react-redux';

export const useIsLoggedIn = () => useSelector((state) => Boolean(state.auth.token));
export const useToken = () => useSelector((state) => state.auth.token);
export const useUserInfo = () => useSelector((state) => state.auth.decodedData);
